import { TimetableTemplate } from '@wui/common-library'
import { AxiosResponse } from 'axios'

import {
  SubscriberService,
  Scenarios,
} from '@/shared/types/settings'
import { getAppURL } from '@/shared/utils/electron'
import { FetchResponse, useFetchApi } from '@/shared/utils/fetch'

import { ForwardingConditions, Forwarding } from '../types'

export const useSettingsApi = () => {
  const useFetch = useFetchApi()

  return {
    getForwarding (
      condition?: ForwardingConditions,
    ): Promise<AxiosResponse<Forwarding[]> | FetchResponse<Forwarding[]>> {
      let path = getAppURL({ pathName: '/api/Forwarding' })

      if (condition) {
        path += `?condition=${condition}`
      }

      return useFetch.get(path)
    },
    getSubscriberServices (): Promise<AxiosResponse<SubscriberService> | FetchResponse<SubscriberService>> {
      return useFetch.get(getAppURL({ pathName: '/api/subscriber-service' }))
    },
    getScenarios (): Promise<AxiosResponse<Scenarios> | FetchResponse<Scenarios>> {
      return useFetch.get(getAppURL({ pathName: '/api/Scenario' }))
    },
    removeForwardingItem (guid: string): Promise<AxiosResponse | FetchResponse> {
      return useFetch.delete(getAppURL({ pathName: `/api/Forwarding/${guid}` }))
    },
    addForwarding (forwarding: Forwarding): Promise<AxiosResponse | FetchResponse> {
      return useFetch.post(getAppURL({ pathName: '/api/Forwarding' }), forwarding)
    },
    saveForwarding (forwarding: Forwarding): Promise<AxiosResponse | FetchResponse> {
      return useFetch.put(getAppURL({ pathName: '/api/Forwarding' }), forwarding)
    },
    getTimetableTemplates (): Promise<AxiosResponse<TimetableTemplate[]> | FetchResponse<TimetableTemplate[]>> {
      return useFetch.get(getAppURL({ pathName: '/api/timetable-template' }))
    },
  }
}
